import Case from "case";

export const getNamedLanguages = (isoCodes: string[]) => {
  return isoCodes.reduce<string[]>((acc, code) => getLanguageNativeName(code) ? [...acc, code] : acc, []);
};

export const getLanguageNativeName = (isoCode: string) => {
  const nativeName = new Intl.DisplayNames([isoCode], { type: "language" }).of(isoCode);
  return nativeName && nativeName !== isoCode ? Case.capital(nativeName) : undefined;
};

export const getSelectedLanguageName = (selectedIsoCode: string, availableIsoCode: string[]) => {
  return getLanguageNativeName(availableIsoCode.find((code) => code === selectedIsoCode) || "en");
};
